import { DocumentId } from 'api/models';

export const getDocumentName = ([, docId]: DocumentId, id: string): string => {
  return `rl-doc-${docId}-${id}-v28`;
};
